var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xED\x9D\xB0\xEC\x83\x89 \xEC\x8B\xAC\xEB\xB3\xBC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.524971 7.20257C0.39512 7.20257 0.265026 7.1547 0.163244 7.05796C-0.0469091 6.85815 -0.0552078 6.52545 0.14445 6.31513C1.40268 4.99043 1.40268 2.91532 0.14445 1.59062C-0.0552078 1.3803 -0.0469091 1.04784 0.163244 0.847784C0.373397 0.647724 0.705591 0.656273 0.905492 0.866593C2.54962 2.59728 2.54962 5.30847 0.905492 7.03891C0.802246 7.14761 0.663853 7.20233 0.524971 7.20233V7.20257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.50424 7.20272C7.36536 7.20272 7.22696 7.14801 7.12372 7.03931C5.47959 5.30862 5.47959 2.59742 7.12372 0.866743C7.32338 0.656423 7.65581 0.648117 7.86597 0.847934C8.07612 1.04775 8.08442 1.38045 7.88476 1.59077C6.62628 2.91547 6.62628 4.99058 7.88476 6.31528C8.08442 6.5256 8.07612 6.85805 7.86597 7.05812C7.76443 7.15485 7.63433 7.20272 7.50424 7.20272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.03554 3.98084C2.84028 3.98084 1.89252 3.6093 1.30282 3.29345C1.03091 3.14787 0.928398 2.80906 1.07411 2.53694C1.21959 2.26482 1.55813 2.16222 1.83003 2.30805C2.31721 2.56918 3.10681 2.87697 4.10364 2.8628C5.02285 2.84936 5.75362 2.5643 6.20517 2.32735C6.4783 2.18396 6.81586 2.28949 6.95914 2.56283C7.10241 2.83617 6.99697 3.174 6.72384 3.31739C5.92228 3.73803 5.02163 3.96741 4.11999 3.9806C4.09192 3.98109 4.06385 3.98133 4.03603 3.98133L4.03554 3.98084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.85096 1.24824C3.1052 1.24824 3.3113 0.968813 3.3113 0.62412C3.3113 0.279428 3.1052 0 2.85096 0C2.59672 0 2.39062 0.279428 2.39062 0.62412C2.39062 0.968813 2.59672 1.24824 2.85096 1.24824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.17909 1.24824C5.43332 1.24824 5.63942 0.968813 5.63942 0.62412C5.63942 0.279428 5.43332 0 5.17909 0C4.92485 0 4.71875 0.279428 4.71875 0.62412C4.71875 0.968813 4.92485 1.24824 5.17909 1.24824Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotProfile);
export default __webpack_public_path__ + "static/media/botProfile.9fadd1ceb1bf8a5110c91ae0956d8de4.svg";
export { ForwardRef as ReactComponent };